import { FAQ_BANNER_HEADER_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[FAQ_BANNER_HEADER_MODULE_ID]: {
		moduleType: 'bannerHeader',
		bannerImageText: 'FAQ',
		textWithBg: false,
	},
}
